import { Event } from "@/models/Events.model";
import { create } from "zustand";

type EventsState = {
  events: Event[] | null;
  setEvents: (events: Event[]) => void;
};

export const useEventStore = create<EventsState>(
  (set: (partial: Partial<EventsState>) => void) => ({
    events: null,
    setEvents: (newEvents) =>
      set({
        events: newEvents,
      }),
  })
);
